import React from 'react';

// Myriad Pro font inladen
const style = document.createElement('style');
style.textContent = `
  @font-face {
    font-family: 'MyriadPro';
    src: url('/fonts/MyriadPro-Bold.woff2') format('woff2');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }
`;
document.head.appendChild(style);
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
